import { SessionModel } from '../sessions/models/session';

export function CoreTranslateConfig (
  $translateProvider : ng.translate.ITranslateProvider
) {
  const defaultLanguage        = 'en-uk';
  const session : SessionModel = angular.fromJson(sessionStorage.session_object);

  const preferredLanguage = session?.company_settings
    ? ( session.company_settings.language || this.defaultLanguage )
    : 'en-uk';

  $translateProvider.useStaticFilesLoader(
    {
      prefix: 'lang/locale-',
      suffix: '.json'

    }
  )
  .preferredLanguage(preferredLanguage)
  .fallbackLanguage(defaultLanguage)
  .useSanitizeValueStrategy('sanitizeParameters');
}